import { render, staticRenderFns } from "./hanfu.vue?vue&type=template&id=50afda34&scoped=true&"
import script from "./hanfu.vue?vue&type=script&lang=js&"
export * from "./hanfu.vue?vue&type=script&lang=js&"
import style0 from "./hanfu.vue?vue&type=style&index=0&id=50afda34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50afda34",
  null
  
)

export default component.exports